import { render, staticRenderFns } from "./WeekGiftConfig.vue?vue&type=template&id=5c50024a&scoped=true"
import script from "./WeekGiftConfig.vue?vue&type=script&lang=js"
export * from "./WeekGiftConfig.vue?vue&type=script&lang=js"
import style0 from "./WeekGiftConfig.vue?vue&type=style&index=0&id=5c50024a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50024a",
  null
  
)

export default component.exports